namespace TabAurous.OMS {
    export interface VoucherMasterForm {
        VoucherTypeName: Serenity.StringEditor;
        TypeOfVoucher: Serenity.LookupEditor;
        VoucherCode: Serenity.StringEditor;
        MethodOfVoucherNumbering: VoucherMasterEditor;
        AutoPosting: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsDefault: Serenity.BooleanEditor;
        IsTaxApplicable: Serenity.BooleanEditor;
        AllowBackDatedEntry: Serenity.BooleanEditor;
        LedgerId: Serenity.ServiceLookupEditor;
        MasterId: Serenity.IntegerEditor;
        Heading1: Serenity.StringEditor;
        Heading2: Serenity.StringEditor;
        Heading3: Serenity.StringEditor;
        Heading4: Serenity.StringEditor;
        Narration: Serenity.TextAreaEditor;
        Declaration: Serenity.TextAreaEditor;
        Terms: Serenity.TextAreaEditor;
        MenuId: Serenity.IntegerEditor;
        StockUpdateMode: Serenity.StringEditor;
        DefaultMetalDepartment: Serenity.LookupEditor;
        DefaultStoneDepartment: Serenity.LookupEditor;
        DefaultJewelleryDepartment: Serenity.LookupEditor;
        DefaultOthersDepartment: Serenity.LookupEditor;
        Prefix: Serenity.StringEditor;
        Separator: SeparatorEditor;
        PrefixDate: PrefixEditor;
        Suffix: Serenity.StringEditor;
        IncrementBy: Serenity.IntegerEditor;
        LastNumber: Serenity.IntegerEditor;
        PrefillwithZero: Serenity.BooleanEditor;
        Noofzeroes: Serenity.IntegerEditor;
        BranchWise: Serenity.BooleanEditor;
        CounterWise: Serenity.BooleanEditor;
        ResetMonthly: Serenity.BooleanEditor;
        ResetYearly: Serenity.BooleanEditor;
        Format: Serenity.StringEditor;
        Lock: Serenity.BooleanEditor;
        Details: VoucherTaxDetailsEditor;
    }

    export class VoucherMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.VoucherMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!VoucherMasterForm.init)  {
                VoucherMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = VoucherMasterEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.TextAreaEditor;
                var w7 = SeparatorEditor;
                var w8 = PrefixEditor;
                var w9 = VoucherTaxDetailsEditor;

                Q.initFormType(VoucherMasterForm, [
                    'VoucherTypeName', w0,
                    'TypeOfVoucher', w1,
                    'VoucherCode', w0,
                    'MethodOfVoucherNumbering', w2,
                    'AutoPosting', w3,
                    'IsDisabled', w3,
                    'IsDefault', w3,
                    'IsTaxApplicable', w3,
                    'AllowBackDatedEntry', w3,
                    'LedgerId', w4,
                    'MasterId', w5,
                    'Heading1', w0,
                    'Heading2', w0,
                    'Heading3', w0,
                    'Heading4', w0,
                    'Narration', w6,
                    'Declaration', w6,
                    'Terms', w6,
                    'MenuId', w5,
                    'StockUpdateMode', w0,
                    'DefaultMetalDepartment', w1,
                    'DefaultStoneDepartment', w1,
                    'DefaultJewelleryDepartment', w1,
                    'DefaultOthersDepartment', w1,
                    'Prefix', w0,
                    'Separator', w7,
                    'PrefixDate', w8,
                    'Suffix', w0,
                    'IncrementBy', w5,
                    'LastNumber', w5,
                    'PrefillwithZero', w3,
                    'Noofzeroes', w5,
                    'BranchWise', w3,
                    'CounterWise', w3,
                    'ResetMonthly', w3,
                    'ResetYearly', w3,
                    'Format', w0,
                    'Lock', w3,
                    'Details', w9
                ]);
            }
        }
    }
}
